import { FormattedMessage as FM } from "react-intl";

import CardBasic from "componentsv2/card/CardBasic";
import { cn, colors } from "tools/ui";

const style = "grid gap-3 mt-8";
let _size = "p-4";

function SelectionCardField(props) {
  const {
    name,
    field,
    data,
    readOnly,
    options = [],
    label,
    onChange,
    sizeLabel = "text-md",
    numCol = "4",
    min = false,
  } = props;

  const col = `grid-cols-${numCol}`;
  _size = min ? _size : "";

  let color = "bg-transparent";
  let disabled = "";
  if (readOnly) {
    color = colors.readOnly;
    disabled = "pointer-events-none";
  }

  function selectedItem(item) {
    data.value = item;
    if (onChange) {
      onChange(name, value);
    }
  }

  return (
    <div className="w-full pb-5">
      {label && (
        <h3
          className={cn(
            "mt-3 mb-2 ml-1 font-bold text-zinc-500 max-h-5",
            sizeLabel,
          )}
        >
          <FM id={label} />
        </h3>
      )}
      <div className={cn(style, col, color, _size, disabled)}>
        {options.map((rec) => (
          <CardBasic
            key={rec.id}
            onClick={() => selectedItem(rec)}
            record={rec}
            color="gray"
            current={data.value?.id === rec.id}
            size="w-full"
            margin=""
          />
        ))}
      </div>
    </div>
  );
}

export default SelectionCardField;
